module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RcltJi/tc-custom/9781459222809.jpg?1705038283435",
      "alt": "This image is the cover for the book Question of Trust, The Izzy McNeil Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Question of Trust, The Izzy McNeil Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Keep your friends close and your enemies closer. But what if you can't tell which is which?")]), _c('br'), _c('br'), _vm._v("When attorney Izzy McNeil's home is broken into, right after her boyfriend, Theo, moves in, she ignores the coincidence. When Theo is arrested on charges of fraud, she wants to believe he's innocent. But when a neighbor is found dead, she can't ignore that something is very, very wrong."), _c('br'), _c('br'), _vm._v("Izzy also can't forget how Theo was inexplicably turned down for a mortgage. Or his recent moody silences. Or how a stranger warned her that Theo needs to \"accept responsibility\""), _c('br'), _c('br'), _vm._v("Thrust into Theo's case, Izzy must walk the line between attorney and lover to prove that Theo is innocent. But only Izzy can decide whether trusting Theo will keep her safeor throw her into unimaginable danger."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Caldwell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Laura Caldwell, a former trial lawyer, is currently a professor and Distinguished Scholar in Residence at Loyola University Chicago School of Law. She is the author of eleven novels and one non-fiction book. She is a nation-wide speaker and the founder of Life After Innocence, which helps innocent people begin their lives again after being wrongfully imprisoned. Laura has been published in thirteen languages and over twenty countries. To learn more, please visit www.lauracaldwell.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0